import { render, staticRenderFns } from "./LocalAgentCard.vue?vue&type=template&id=f315b3c6&scoped=true"
import script from "./LocalAgentCard.vue?vue&type=script&lang=js"
export * from "./LocalAgentCard.vue?vue&type=script&lang=js"
import style0 from "./LocalAgentCard.vue?vue&type=style&index=0&id=f315b3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f315b3c6",
  null
  
)

export default component.exports